/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IExtVideoPlayer contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum textTheme {
    dark = 'dark',
    light = 'light'
}

export const enum contentPositionX {
    start = 'start',
    center = 'center',
    end = 'end'
}

export const enum contentPositionY {
    start = 'start',
    center = 'center',
    end = 'end'
}

export const enum textAlignment {
    start = 'start',
    center = 'center',
    end = 'end'
}

export const enum mobileVideoQuality {
    hdx = 'hdx',
    hq = 'hq',
    sd = 'sd',
    lo = 'lo'
}

export interface IExtVideoPlayerConfig extends Msdyn365.IModuleConfig {
    heading: IHeadingData;
    video: Msdyn365.IVideoData;
    overlay?: boolean;
    paragraph?: Msdyn365.RichText;
    textTheme?: textTheme;
    links?: ILinksData[];
    videoLink?: Msdyn365.ILinkData;
    additionalContent?: IAdditionalContentData;
    contentPositionX?: contentPositionX;
    contentPositionY?: contentPositionY;
    topMargin?: number;
    rightMargin?: number;
    bottomMargin?: number;
    leftMargin?: number;
    textAlignment?: textAlignment;
    autoplay?: boolean;
    mute?: boolean;
    loop?: boolean;
    autoCaptions?: string;
    playPauseTrigger?: boolean;
    controls?: boolean;
    playFullScreen?: boolean;
    hidePosterFrame?: boolean;
    maskLevel?: number;
    thumbnailFullWidth?: boolean;
    lazyLoad?: boolean;
    clientRender?: boolean;
    mobileVideoQuality?: mobileVideoQuality;
    shouldDisableAutoPlayOnMobile?: boolean;
}

export interface IExtVideoPlayerResources {
    playLabel: string;
    pauseLabel: string;
    pausedLabel: string;
    playingLabel: string;
    unMuteLabel: string;
    muteLabel: string;
    fullScreenLabel: string;
    exitFullScreenLabel: string;
    seekBarLabel: string;
    videoTimeDurationLabel: string;
    closedCaptionLabel: string;
    optionButtonLabel: string;
    sliderThumbLabel: string;
    volumeThumbLabel: string;
}

export const enum HeadingFontFamily {
    ConvEuropaBold = 'ConvEuropaBold',
    ConvEuropaRegular = 'ConvEuropaRegular',
    ConvEuropaLight = 'ConvEuropaLight',
    BodoniRegular = 'BodoniRegular',
    BodoniSmallCaps = 'BodoniSmallCaps',
    BodoniBold = 'BodoniBold',
    BodoniOSRegular = 'BodoniOSRegular',
    BodoniOSBold = 'BodoniOSBold',
    BodoniOSItalic = 'BodoniOSItalic',
    HelveticaNeue = 'HelveticaNeue',
    HelveticaNeueBold = 'HelveticaNeueBold',
    HelveticaNeueLight = 'HelveticaNeueLight',
    Manus = 'Manus'
}

export interface IHeadingData {
    text: string;
    fontFamily: HeadingFontFamily;
    fontSize: number;
    fontColor: string;
}

export interface ILinksData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IAdditionalContentData {
    heading?: string;
    subtext?: string;
    links?: ILinksData[];
}

export interface ILinksData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IExtVideoPlayerProps<T> extends Msdyn365.IModule<T> {
    resources: IExtVideoPlayerResources;
    config: IExtVideoPlayerConfig;
}
